<div class="ap-popup-overlay" (click)="onCancel()">
  <div class="ap-popup" (click)="$event.stopPropagation()">

    @if (isLoading) {
      <div class="ap-popup-loading">
        <div class="spinner"></div>
        <p class="text-load">&nbsp;&nbsp; Loading...</p>
      </div>
    }

    <!-- Header -->
    <div class="ap-popup-header">
      <h2 class="ap-id-heading">Action Plan ID: <span class="ap-id-value">AP-{{ actionPlanId }}</span></h2>
    </div>

    <!-- Body -->
    <div class="ap-popup-body">

      <!-- Row 1: Description | Closed Date | Internal Dependency -->
      <div class="form-grid">
        <div class="field-group">
          <label class="field-label">Action Plan Description</label>
          <div class="field-input field-textarea">{{ actionPlan.description }}</div>
        </div>
        <div class="field-group">
          <label class="field-label">Closed Date for the Action Plan</label>
          <div class="field-input">{{ formatDateDisplay(actionPlan.closedDate) }}</div>
        </div>
        <div class="field-group">
          <label class="field-label">Internal Dependency</label>
          <div class="field-input">{{ actionPlan.internalDependency }}</div>
        </div>
      </div>

      <!-- Row 2: Target Date | Owner | Action Plan Status -->
      <div class="form-grid">
        <div class="field-group">
          <label class="field-label">Target Date for Action Plan/Remediation Action</label>
          <div class="field-input">{{ formatDateDisplay(actionPlan.targetDate) }}</div>
        </div>
        <div class="field-group">
          <label class="field-label">Owner for Action Plan/Remediation Action</label>
          <div class="field-input field-placeholder">Search</div>
          <div class="tags-row">
            @for (owner of actionPlan.owners; track owner) {
              <span class="tag">{{ owner.split('@')[0] }} <span class="tag-x tag-x--disabled">&#x2715;</span></span>
            }
          </div>
        </div>
        <div class="field-group">
          <label class="field-label">Action Plan Status</label>
          <div class="field-input">{{ actionPlan.actionPlanStatus }}</div>
        </div>
      </div>

      <!-- Row 3: Revised Target Date | R&C Comments | Upload File -->
      <div class="form-grid">
        <div class="field-group">
          <label class="field-label">Revised Target Date</label>
          <div class="field-input">{{ formatDateDisplay(actionPlan.revisedTargetDate) }}</div>
        </div>
        <div class="field-group">
          <label class="field-label">{{ isGoLive ? 'R&C Comments for Action Plan' : 'R&C Comments' }}</label>
          <div class="field-input field-textarea">{{ actionPlan.rcComments }}</div>
        </div>
        <div class="field-group">
          <label class="field-label">Upload File</label>
          @if (actionPlan.uploadedDocuments.length > 0) {
            <div class="upload-doc-area">
              <div class="upload-doc-trigger">
                <span class="material-symbols-outlined upload-doc-icon">attach_file</span>
                <span class="upload-doc-label">Attach Document</span>
              </div>
              @for (doc of actionPlan.uploadedDocuments; track doc.documentId) {
                <div class="upload-doc-item">
                  <span class="doc-filename doc-filename--link" (click)="downloadDocument(doc)">{{ doc.fileName }}</span>
                </div>
              }
            </div>
          } @else {
            <div class="field-upload">
              <span class="material-symbols-outlined upload-icon">attach_file</span>
              <span class="upload-text">Upload Document</span>
            </div>
          }
        </div>
      </div>

      <!-- Row 4: Client Dependency | Red Client Date | Target Date to Inform -->
      <div class="form-grid">
        <div class="field-group">
          <label class="field-label">Client Dependency</label>
          <div class="radio-group">
            <label class="radio-label radio-label--readonly">
              <input type="radio" name="clientDependencyRO" value="yes"
                [checked]="actionPlan.clientDependency === 'yes'" disabled />
              Yes
            </label>
            <label class="radio-label radio-label--readonly">
              <input type="radio" name="clientDependencyRO" value="no"
                [checked]="actionPlan.clientDependency === 'no'" disabled />
              No
            </label>
          </div>
        </div>
        <div class="field-group">
          <label class="field-label">{{ isGoLive ? 'Red-Client related observation-Client informed date' : 'Red Client Observation Client Informed Date' }}</label>
          <div class="field-input">{{ formatDateDisplay(actionPlan.redClientObservationDate) }}</div>
        </div>
        <div class="field-group">
          <label class="field-label">Target Date to Inform Red Client Observation Client Informed Date</label>
          <div class="field-input">{{ formatDateDisplay(actionPlan.targetDateToInformClient) }}</div>
        </div>
      </div>

      <div class="form-grid">
        <div class="field-group">
          <label class="field-label">Legacy AP Number (AuditBoard AP ID)</label>
          <div class="field-input">{{ actionPlan.legacyApNumber }}</div>
        </div>
      </div>

    </div>

    <!-- Footer -->
    <div class="ap-popup-footer">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-update" disabled>Update</button>
    </div>

  </div>
</div>
